import { homePath } from '../app-shell/constants';

const deniedBounceKey = 'sgs-denied-bounce';

function readBounce(): string {
  let bounce = '';
  try {
    bounce = window.sessionStorage.getItem(deniedBounceKey) || '';
  } catch {} // No session storage means no loop guard, and the denial page answers instead
  return bounce;
}

export function claimDeniedBounce(): boolean {
  let claimed = false;
  if (readBounce().length === 0) {
    try {
      window.sessionStorage.setItem(deniedBounceKey, window.location.pathname);
      claimed = true;
    } catch {} // Without the guard a second denial would loop, so stay put instead
  }
  return claimed;
}

export function hasDeniedBounce(): boolean {
  return readBounce().length > 0;
}

export function canGuardDeniedBounce(): boolean {
  let available = false;
  try {
    available = typeof window.sessionStorage.setItem === 'function';
  } catch {} // Blocked storage cannot guard the loop, so the denial page answers in place
  return available;
}

export function forgetDeniedBounce(): void {
  try {
    window.sessionStorage.removeItem(deniedBounceKey);
  } catch {} // Nothing stored, nothing to forget
}

export function leaveForHome(): void {
  window.location.assign(homePath);
}
